module.exports = __webpack_public_path__ + "img/ic_qmarker_trailer_lbl.34176f19.png";